module.exports = __webpack_public_path__ + "static/media/Verification.c4f60d38.png";